export default __webpack_public_path__ + "static/media/green-trane-BA-logo.6e256625.svg";